// import ApiService from '@/services/api.services'
import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const ItemImagesService = {
    getImagesWaitingForProcess: async () => {
        const url = `/api/ItemImageProcess/GetImagesWaitingForProcess`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    uploadImagesToCloud: async () => {
        const url = `/api/ItemImageProcess/UploadImagesToCloud`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    // rename or delete file
    fileOperation: async (payload) => {
        const url = `/api/ItemImageProcess/FileOperation`

        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    getTotalImageRpt: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemImageProcess/GetTotalImageRpt',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    searchItemImageAdvanced: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemImageProcess/SearchItemImageAdvanced',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    deleteItemImage: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemImageProcess/DeleteItemImage?id=' + payload,
            data: null,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    updateItemImageHidenRoles: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemImageProcess/UpdateItemImageHidenRoles',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
}

export default ItemImagesService